<p v-if="isLoading" class="basis-full text-center p-3 text-gray-500">
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-2 h-2 mx-auto stroke-primary animate-spin">
        <path stroke-linecap="round" stroke-linejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" />
      </svg>
      <br />
    loading...</p>

<ul v-else-if="results.length" class="basis-full grid sm:grid-cols-[repeat(auto-fill,_minmax(424px,_1fr))] gap-1 lg:gap-1.5 xl:gap-2 grid-view">
    <li class="relative group" v-for="item in results" :key="item.objectID">
        <div class="relative">
            <div class="w-full overflow-hidden mb-1">
                <img
                    class="w-full aspect-[3/2] object-cover group-hover:opacity-70 group-hover:scale-[1.02] group-hover:ease-in-out duration-300"
                    v-if="item.objectImage"
                    :src="item.objectImage"
                    loading="lazy"
                    alt=""
                    width="600"
                    height="400"
                />
                <img
                    class="w-full aspect-[3/2] group-hover:opacity-70 group-hover:scale-[1.02] group-hover:ease-in-out duration-300"
                    v-else
                    src="../assets/no-image-1x1.png"
                    loading="lazy"
                    alt=""
                    width="600"
                    height="400"
                />
            </div>
            <div class="absolute -bottom-1.25 right-1 z-10">
                <favourite-icon
                    :type="item.objectType"
                    :key="item.objectID"
                    :id="item.objectSilverstripeID"
                    :cssClasses="favButtonCssClasses"
                />
            </div>
        </div>

        <div class="flex items-center gap-1.25" v-if="item.objectCategory || item.objectCategories || item.objectType">
            <p class="bg-primary-lightest text-primary text-xs font-bold uppercase p-qtr tracking-wider mb-half" v-if="item.objectType === 'Listing'">Maker Information</p>
            <p class="bg-primary-lightest text-primary text-xs font-bold uppercase p-qtr tracking-wider mb-half" v-else>Maker Story</p>

            <button
                v-if="item.objectCategory && item.objectType === 'Listing' && categoriesFacets && categoriesFacets.find(facet => facet.title === item.objectCategory)"
                @click="
                    () => {
                        const matchingFacet = categoriesFacets.find(facet => facet.title === item.objectCategory);
                        if (matchingFacet) {
                            $emit('update:selectedCategory', matchingFacet.category);
                            scrollToIlMadeWrapper();
                        }
                    }
                "
                class="relative z-50 text-primary text-xs font-bold hover:text-primary-dark hover:underline uppercase whitespace-nowrap overflow-hidden text-ellipsis tracking-wider mb-half focus:outline-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-primary focus-visible:outline-offset-2"
            >
                {{ item.objectCategory }}
            </button>
            <p v-else-if="item.objectCategory && item.objectType === 'Listing'" class="text-primary text-xs font-bold uppercase whitespace-nowrap overflow-hidden text-ellipsis tracking-wider mb-half">
                {{ item.objectCategory }}
            </p>

            <button
                v-else-if="item.objectCategory && item.objectType === 'Page' && categoriesFacets && categoriesFacets.find(facet => facet.title === getCategoryName(item.objectCategories[0]))"
                @click="
                    () => {
                        const matchingFacet = categoriesFacets.find(facet => facet.title === getCategoryName(item.objectCategories[0]));
                        if (matchingFacet) {
                            $emit('update:selectedCategory', matchingFacet.category);
                            scrollToIlMadeWrapper();
                        }
                    }
                "
                class="relative z-50 text-primary text-xs font-bold hover:text-primary-dark hover:underline uppercase whitespace-nowrap overflow-hidden text-ellipsis tracking-wider mb-half focus:outline-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-primary focus-visible:outline-offset-2"
            >
                {{ getCategoryName(item.objectCategories[0]) }}
            </button>
            <p v-else-if="item.objectCategories && item.objectType === 'Page'" class="text-primary text-xs font-bold uppercase whitespace-nowrap overflow-hidden text-ellipsis tracking-wider mb-half ">
                {{ getCategoryName(item.objectCategories[0]) }}
            </p>
        </div>

        <h3 class="h4 group-hover:text-primary w-11/12">{{ item.objectTitle }}</h3>

        <p class="text-sm mb-half" v-if="showPublishDate && item.objectPublishDate">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="stroke-primary w-1.5 h-1.5 inline">
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 6.042A8.967 8.967 0 0 0 6 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 0 1 6 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 0 1 6-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0 0 18 18a8.967 8.967 0 0 0-6 2.292m0-14.25v14.25" />
              </svg>

            <span class="text-gray-500 ml-qtr">
                {{ item.objectPublishDate }}
            </span>
        </p>

        <p class="text-sm flex-row text-lightgray gap-1" v-if="item.objectDuration || item.objectDistance">
            <span :class="item.objectDistance && 'mr-1'" v-if="item.objectDuration">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-1.5 h-1.5 inline text-primary">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
            {{ item.objectDuration }}
            </span>
            <span v-if="item.objectDistance" >
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-1.5 h-1.5 inline text-primary">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M9 6.75V15m6-6v8.25m.503 3.498l4.875-2.437c.381-.19.622-.58.622-1.006V4.82c0-.836-.88-1.38-1.628-1.006l-3.869 1.934c-.317.159-.69.159-1.006 0L9.503 3.252a1.125 1.125 0 00-1.006 0L3.622 5.689C3.24 5.88 3 6.27 3 6.695V19.18c0 .836.88 1.38 1.628 1.006l3.869-1.934c.317-.159.69-.159 1.006 0l4.994 2.497c.317.158.69.158 1.006 0z" />
                </svg>
                {{ item.objectDistance }}
            </span>
        </p>
        <p class="mt-0 text-black w-11/12">{{ item.objectSummary }}</p>
        <a class="absolute-cover" :href="item.objectLink"><span class="sr-only">{{ item.objectTitle }}</span></a>
    </li>
</ul>
